import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { photoSrc } from "@/lib/api";

const EASE = [0.22, 1, 0.36, 1];
const SPANS = [
  "md:col-span-7 md:row-span-2 aspect-[4/3] md:aspect-auto",
  "md:col-span-5 aspect-[4/3]",
  "md:col-span-5 aspect-[4/3]",
  "md:col-span-4 aspect-square",
  "md:col-span-4 aspect-square",
  "md:col-span-4 aspect-square",
];

export const Album = () => {
  const { photos, lang } = useSite();

  return (
    <section id="album" data-testid="album-section" className="py-32 bg-sky-50/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="flex flex-wrap items-end justify-between gap-6"
        >
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-orange-500">
              {lang === "zh" ? "团队相册" : "Photo Album"}
            </p>
            <h2 className="mt-4 font-display font-extrabold tracking-tight text-4xl sm:text-5xl text-slate-900">
              {lang === "zh" ? "镜头下的我们" : "Us, Through the Lens"}
            </h2>
          </div>
          <p className="flex items-center gap-2 text-sm font-semibold text-slate-500">
            <Camera size={16} className="text-sky-500" />
            {photos.length} {lang === "zh" ? "张照片" : "photos"}
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-6 md:auto-rows-[240px]">
          {photos.map((p, i) => (
            <motion.figure
              key={p.id}
              data-testid={`album-photo-${i}`}
              initial={{ opacity: 0, y: 40, scale: 0.97 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.12, ease: EASE }}
              className={`group relative overflow-hidden rounded-3xl bg-slate-200 ${SPANS[i % SPANS.length]}`}
            >
              <img
                src={photoSrc(p)}
                alt={lang === "zh" ? p.caption_zh : p.caption_en}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-900/70 to-transparent p-5 pt-12 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
                <p className="text-sm font-bold text-white">{lang === "zh" ? p.caption_zh : p.caption_en}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
